import RoboChat from '../../../../icons/RoboChat.svg?react';
import { EasyStepsConfirmationData, EasyStepsScheduleData } from '../../Common/Appointment/CustomAppointmentData';

export const EasyStepsSchedule = EasyStepsScheduleData;

export const EasyStepsConfirmation = EasyStepsConfirmationData;

export const InsurancePlan = [
  {
    title: "Need Help?",
    content: "Getting your spouse or partner insured can be just as important as your own insurance.",
    icon: RoboChat,
    btnTitle: 'GET A QUOTE',
    linkTo: '/landing/whole-life'
  },
  {
    title: "Other Insurance Options",
    content: "Explore coverage options in a variety of categories, all from your mobile device.",
    icon: RoboChat,
    btnTitle: 'SEE PRODUCTS',
    linkTo: '/'
  },
  {
    title: "Policy Review",
    content: "If you have existing life insurance coverage, we provide a complimentary policy review service to ensure your coverage meets your needs / budget.",
    icon: RoboChat,
    btnTitle: 'GET A POLICY REVIEW',
    linkTo: '/policy-review'
  },
];
